import React from 'react';

type ItemSummaryProps = {
    itemType: string;
    itemId: string;
};

export const ItemSummary = (props: ItemSummaryProps) => {
    switch (props.itemType) {
        case 'project':
            return <ProjectSummary itemId={props.itemId} />
    }

    return (
        <span>
            Unsupported item type '{props.itemType}' with id '{props.itemId}'
        </span>
    );
};

type ProjectSummaryProps = {
    itemId: string;
}

const ProjectSummary = (props: ProjectSummaryProps) => {
    return (
        <span>
            Project with id '{props.itemId}'
        </span>
    );
};
